import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ValidatorHelper } from 'components/custom-validators/validators.helper';
import { CommonFunc } from '../../common/common-func/common-func';
import { IndividualAccountService } from '../../../api-services/individual-account.service';
import { Subscription } from 'rxjs';
import { TenantType } from 'shared/constant';

@Component({
  selector: 'app-individual-registration',
  templateUrl: './individual-registration.component.html',
  styleUrls: ['./individual-registration.component.css']
})
export class IndividualRegistrationComponent implements OnInit {

  errorMessages = [];
  userIndRegForm!: FormGroup;
  isShow: boolean = true;
  isValid: boolean = true;
  TenantType = TenantType;
  subscription: Subscription[] = [];
  mask: any[] = [/[2-9]{1}/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  constructor(private router: Router, private fb: FormBuilder, private individualAccountService: IndividualAccountService
    , private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {

    this.userIndRegForm = this.fb.group({
      firstName: ['', [Validators.required,Validators.maxLength(50)]],
      lastName: ['', [Validators.required,Validators.maxLength(50)]],
     // businessName: ['', [Validators.required,Validators.maxLength(50)]],
      phoneNumber: ['', [Validators.required, ValidatorHelper.phonePattern]],
      npn: ['', [Validators.required, Validators.pattern("[0-9]{0,10}(,[0-9]{0,10})*")]],
      email: ['', [Validators.required, ValidatorHelper.emailPattern,Validators.maxLength(255)]],
      password: ['', [ValidatorHelper.passwordPattern, Validators.required,]],
      // confirmPassword: ['', [ValidatorHelper.passwordPattern, Validators.required,]],
      agree: ['', [Validators.requiredTrue]],
      reCaptcha: ['', [Validators.required]],
      platformId: 1
    });
  }

  touchEmail() {   
    this.errorMessages = [];
  }

  onSubmit() {
    this.errorMessages = [];
    this.userIndRegForm.markAllAsTouched();
    this.userIndRegForm.updateValueAndValidity();
    if (this.userIndRegForm.valid) {
      delete this.userIndRegForm.value['reCaptcha'];

      this.subscription.push(this.individualAccountService.createIndividualAccountStaging(this.userIndRegForm.value).subscribe(
        (response: any) => {
          if (response.individualAccountStagingId > 0) {
            localStorage.setItem("individualAccountStagingId", response.individualAccountStagingId.toString());
            //sessionStorage.setItem('indUser', JSON.stringify(this.userIndRegForm.value));
            this.router.navigate(['individual/activate/'], { queryParams: { id: response.encUserId, page: "indReg" }});
          }
          else {
            this.errorMessages.push(response.rtnMessage);
          }
        },
        (error: any) => {
          this.errorMessages.push(error.message);
        }
      ))
    }

    //this.router.navigate(['/individual-registration']);
  }

   resolved(captchaResponse: string) {
    // console.log(`Resolved captcha: ${captchaResponse}`);
  }

  showPassword(id) {
    id == 'setPassword' ? this.isShow = !this.isShow : this.isValid = !this.isValid;
    CommonFunc.showPassword(id);
  }

}
